"use strict";

function _AccountActions() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [];

  this.init = function () {};
  this.initAllReady = function () {};

  this.accountReady = function (data) {
    return {
      type: SET_VERIFIED_ACCOUNT,
      payload: {
        account_ready: data.profile_completed_at && data.verification_level !== 4
      }
    };
  };
}